// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MenuUnfoldOutlinedSvg from "@fishx/icons-svg/es/asn/MenuUnfoldOutlined";
import FishxIcon from '../components/FishxIcon';

var MenuUnfoldOutlined = function MenuUnfoldOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MenuUnfoldOutlinedSvg
  }));
};

MenuUnfoldOutlined.displayName = 'MenuUnfoldOutlined';
export default React.forwardRef(MenuUnfoldOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MenuUnfoldOutlined.js
// module id = 3117
// module chunks = 0